module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Yi Li","short_name":"Yi Li","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/favicon-1024x1024.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"1b09412a9044aa83a55ac75301eb5709"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
